import React, { useState } from "react";
import { Card, Input, Button, Typography, message } from "antd";
import axios from "axios";
import { useSearchParams, useNavigate } from "react-router-dom";
import yogaImg from "../../assets/yoga.jpg";
import { BASE_URL } from "../../Config";

import SuccessPopup from "../../Components/popup/SuccessPopup";
import ErrorPopup from "../../Components/popup/ErrorPopup";

const { Title, Text } = Typography;

export const styles = {
    container: {
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#64b56a",
    },

    card: {
        width: "fit-content",
        borderRadius: "15px",
        overflow: "hidden",
        display: "flex",
    },

    left: {
        maxWidth: "450px",
        padding: "20px",
    },

    right: {
        maxWidth: "450px",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },

    image: {
        width: "100%",
    },

    input: {
        marginTop: "20px",
        height: "40px",
    },

    button: {
        marginTop: "20px",
        height: "45px",
        backgroundColor: "#64b56a",
        color: "#fff",
        fontWeight: "bold",
        border: "none",
    },
};

const ResetPassword = () => {

    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [successPopup, setSuccessPopup] = useState(false);
    const [errorPopup, setErrorPopup] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [params] = useSearchParams();
    const token = params.get("token");

    const handleSubmit = async () => {
        if (!password) {
            setErrorMessage("Password is required");
            setErrorPopup(true);
            return;
        }
        try {
            setLoading(true);
            const res = await axios.post(
                `${BASE_URL}/auth/reset-password`,
                {
                    token,
                    password,
                }
            );
            setSuccessPopup(true);
        }
        catch (err) {
            const msg =
                err.response?.data?.message ||
                "Password reset failed";
            setErrorMessage(msg);
            setErrorPopup(true);
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <Card style={styles.card} bodyStyle={{ padding: 0 }}>
                <div style={styles.left}>
                    <img src={yogaImg} style={styles.image} />
                </div>
                <div style={styles.right}>
                    <Title level={3}>Reset Password</Title>
                    <Text type="secondary">
                        Enter your new password
                    </Text>
                    <Input.Password
                        placeholder="Type your Password"
                        style={styles.input}
                        value={password}
                        onChange={(e) =>
                            setPassword(e.target.value)
                        }
                    />
                    <Button
                        style={styles.button}
                        loading={loading}
                        onClick={handleSubmit}
                        block
                    >
                        RESET PASSWORD
                    </Button>
                </div>
            </Card>
            <SuccessPopup
                open={successPopup}
                message="Password reset successfully!"
                onClose={() => {
                    setSuccessPopup(false);
                    navigate("/login");
                }}
            />
            <ErrorPopup
                open={errorPopup}
                message={errorMessage}
                onClose={() =>
                    setErrorPopup(false)
                }
            />
        </div>
    );
};

export default ResetPassword;